import 'styleguide/styleguide';
import './header';
import './footer';
import './global'
import logEngagement from 'modules/log-engagement';
window.logEngagement = logEngagement;



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/index.js